<template>
  <button type="button" class="btn btn-deleteNote btn-xs" @click="$emit('click')"
          @mouseover="$emit('hover')" @mouseout="$emit('unhover')" :disabled="disabled">
    <template v-if="disabled">
      Deleting
    </template>
    <template v-else>
      Delete
    </template>
  </button>
</template>

<script>
export default {
  name: 'DeleteNoteButton',
  props: {
    disabled: {
      default: false,
      required: false,
      type: Boolean
    }
  }
};
</script>

<style scoped>
.btn-deleteNote {
  background-color: #fff;
  border-style: solid;
  border-width: thin;
  border-color: #555555;
  color: #555555;
  text-transform: uppercase;
  font-size: 0.833rem;
  border-radius: 0;
  font-weight: 400;
  width: 64px;
}
.btn-deleteNote:hover {
  color: #fff !important;
  background-color: #c0392b;
}
</style>
